import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { sportIds, leagueIds } from 'src/constants/personalizationIds'
import { usPlanData } from 'src/constants/planData/usPlanData'

export default (props) => {
  return (
    <USTemplateDefault
      location={props.location}
      lang="en"
      market="us"
      title={'Watch football and more'}
      subtitle={'Stream CBS, ESPN, FOX and 200+ live channels'}
      networkSet="nfl"
      // teams
      team={props.team}
      // Remove cable references
      removeCable={true}
      matchtickerSportId={sportIds.Football}
      matchtickerLeagueName="NFL"
      matchtickerLeagueId={leagueIds.NFL}
      showRedzone={false}
      sportId={sportIds.Football}
      leagueId={leagueIds.NFL}
      hasPlanCards={false}
      plans={[
        usPlanData.elite_monthly,
        { ...usPlanData.pro_monthly, backgroundColor: 'transparent' },
      ]}
      disableAnchor={true}
      poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/NFL-PLAYER-STATIC-HORZ-V2.jpg?ch=width&auto=format,compress"
      posterMobile="https://assets-imgx.fubo.tv/marketing/lp/images/posters/NFL-PLAYER-STATIC-VERT-V2.jpg?ch=width&auto=format,compress"
      {...props}
      caRedirectUrl={'/ca/dazn/'}
    />
  )
}
